import { sortable } from '../interaction/sortable';

const table = ( options) => {
    const { element, rowStyleName, onUpdateOrder, ...nextOptions } = options || {};
    
    const sortOptions = {
        itemClassName: rowStyleName,
        dragX: false,
        onUpdateOrder: (result) => onUpdateOrder(result),
        ...nextOptions,
    }
    
    return sortable(element, sortOptions)
}

const bindIndex = (element, index) => {
    element.dataset.sourceIndex = index;
 //   console.log(element.dataset.sourceIndex, index, getIndex(element));
}

const getIndex = (element) => {
    return element.dataset.sourceIndex;
}

const Sortable = {
    table, 
    bindIndex,
    getIndex
}

export { Sortable };